<a
  [routerLink]="link"
  [queryParams]="queryParams"
>
  <div class="name">{{ name }}</div>
</a>
